import { render, staticRenderFns } from "./LayoffCreate.vue?vue&type=template&id=9144b266"
import script from "./LayoffCreate.vue?vue&type=script&lang=js"
export * from "./LayoffCreate.vue?vue&type=script&lang=js"
import style0 from "./LayoffCreate.vue?vue&type=style&index=0&id=9144b266&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports